export default __webpack_public_path__ + "static/media/bgPatternTextImage.edd0fc12.svg";